module.exports = __webpack_public_path__ + "static/media/Lombre_gaussian2.79fea4e2.png";